module.exports = __webpack_public_path__ + "static/media/intro.b45dcd84.mp3";